var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clos-icon-main") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-tables-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clos-icon-main",
    transform: "translate(0.893398, 0.893398)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(10.606602, 10.606602) rotate(-45.000000) translate(-10.606602, -10.606602) ",
    x: -2.89339828,
    y: 9.10660172,
    width: 27,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    transform: "translate(10.606602, 10.606602) rotate(45.000000) translate(-10.606602, -10.606602) ",
    x: -2.89339828,
    y: 9.10660172,
    width: 27,
    height: 3,
    rx: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconMain);
export default __webpack_public_path__ + "static/media/close-icon-main.34f2f8aea4ca31e206bf9215a3adb0c7.svg";
export { ForwardRef as ReactComponent };